import React, { use, useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import './ChatUI.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoSend } from "react-icons/io5";
import { FaSearch, FaSlash } from "react-icons/fa";
import { LoginContext } from "../../../context/LoginContext"
import axios from 'axios';
import defaultImage from '../others-profiles/default.webp'
import { MessageContext } from "../../../context/MessageContext.js"


const ChatApp = () => {

  const { userData, userId, isLoggedIn } = useContext(LoginContext);
  const { messageUserData, messageName, messageUserId, isMessage, setMessageName, setMessageUserData, setMessageUserId, setIsMessage } = useContext(MessageContext);
  const param = useParams();
  const navigate = useNavigate();
  const [message, setMesssage] = useState([]);
  const [connUser, setConnUsers] = useState([]);
  const [newMessage, setNewMessage] = useState(null);
  const [chatUserName, setChatUserName] = useState("Guest user");
  const [profilePicture, setProfilePicture] = useState(defaultImage);
  const [error, setError] = useState(true);
  const [connId, setConnId] = useState(undefined);
  const [searchName, setSearchName] = useState('');


  const payload = new FormData();
  payload.append("id", userId);
  payload.append("looking", userData.looking_for);
  payload.append("gender", userData.gender);
  payload.append("status", userData.status);
  payload.append("email", userData.email);





  const fetchMessages = (connId) => {

    payload.append("msg_id", connId);
    if (connId) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/message`, payload)
        .then(response => {
          if (response.data.response === 'success') {
            setMesssage(response.data.data);
          }
        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    } else {
      console.log("msg_id Not Set");
    }
  }


  const fetchUsers = () => {

    axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/messageUser`, payload)
      .then(response => {
        if (response.data.response === 'success') {
          setConnUsers(response.data);
          if (param.id != undefined && Array.isArray(response.data.data)) {

            if (response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) })) {

              //////check user seen
              setConnId(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).user_id);

              setChatUserName(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).name);
              setProfilePicture(process.env.REACT_APP_API_BASE_URL + response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).image1);

              fetchMessages(response.data.data.find(user => { return (user.mesg_to === param.id) ? (user.mesg_to == param.id) : (user.mesg_from == param.id) }).user_id);
            }

          }
          if (response.data.data.some(user => user.mesg_to == param.id)) {
            setMessageUserData({});
            setMessageName("Hii Guest");
            setMessageUserId(null);
            setIsMessage(false);
          }
        } else {
          setConnUsers([]);
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });

    if (param.id != messageUserId) {
      setMessageUserData({});
      setMessageName("Hii Guest");
      setMessageUserId(null);
      setIsMessage(false);
    }

  }



  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }

    if (param.id != userId) {
      setConnId(param.id);
      fetchUsers();
      fetchMessages(param.id);
    }

    const interval = setInterval(() => {
      console.log(param.id);
      fetchMessages(param.id);
    }, 1000 * 60 * 1); 

    return () => clearInterval(interval); 

    ///useeffect()
  }, [param.id]);

  const ValiddateInput = () => {
    if (newMessage != "" && newMessage != null && newMessage.trim().length > 0 && newMessage) {
      setError(false);
      return true;
    } else {
      setError(true);
      return false;
    }
  }


  const handleInput = (e) => {
    if (e.target.value != "" && e.target.value != null && e.target.value.trim().length > 0 && e.target.value) {
      setError(false);
    } else {
      setError(true);
    }
    setNewMessage(e.target.value);
  }


  const handleMessageSubmit = () => {
    if (!ValiddateInput) return;

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("msg_to", connId);
    payload.append("msg", newMessage);
    setNewMessage("");
    setError(true);
    axios.post(`${process.env.REACT_APP_API_BASE_URL}message_controller/sendMessage`, payload)
      .then(response => {
        if (response.data.response === 'success') {
          fetchMessages(connId);
          fetchUsers();
          setMessageName(null);
          setError(true);
        }

      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });
  }



  return (
    <div className="container  mt-5 mb-5">

      <div className='chat-app'>
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-4 chat-sidebar p-3">
            <h6 className="mb-3">Chat Messages</h6>
            <div className="input-group mb-3">
              <input type="text" value={searchName} onChange={(e) => setSearchName(e.target.value)} placeholder="Search" className="form-control" />
              <span className="input-group-text bg-white">
                <FaSearch />

              </span>
            </div>

            <div className="chat-user-list">
              {/* User 1 */}
              {/* <div className="chat-user">
              <img src="https://randomuser.me/api/portraits/men/1.jpg" className="chat-avatar" alt="John Smith" />
              <div className="flex-grow-1 ms-2">
                <strong>John Smith</strong>
                <p>Hey, how are you?</p>
              </div>
              <div className="text-end">
                <span className="time d-block">9:00 PM</span>
                <span className="badge rounded-pill bg-danger text-white mt-1">1</span>
              </div>
            </div> */}

              {/* User 2 (Selected) */}
              {(isMessage) && (<Link onClick={messageUserId} to={`/chat/${messageUserId}`}  >
                <div className="chat-user selected">
                  <img src={messageUserData.image1 ? process.env.REACT_APP_API_BASE_URL + messageUserData.image1 : defaultImage} className="chat-avatar" alt={messageName} />
                  <div className="flex-grow-1 ms-2">
                    <strong>{messageName}</strong>
                    {/* <p>Hi</p> */}
                  </div>
                  <div className="text-end">
                    {/* <span className="time">9:00 PM</span> */}
                  </div>
                </div>
              </Link>)}

              {/* User 3 */}
              {connUser?.data?.filter(user => user.name.toLowerCase().includes(searchName.toLowerCase()))?.map(res => (
                <Link onClick={() => { setConnId((res.user_id == res.mesg_from) ? res.mesg_from : res.mesg_to) }} to={`/chat/${(res.user_id == res.mesg_from) ? res.mesg_from : res.mesg_to}`}  >
                  <div className={`chat-user ${(res.mesg_to == param.id) ? "selected" : ""}`} >
                    <img src={res.image1 ? process.env.REACT_APP_API_BASE_URL + res.image1 : defaultImage} className="chat-avatar" alt={res.name} />
                    <div className="flex-grow-1 ms-2">
                      <strong>{res.name}</strong>
                      <p>{res.message}</p>
                    </div>
                    <div className="text-end">
                      <span className="time">{res.date}</span>
                      {connUser?.msgCount?.filter((item) => item.mesg_from == res.mesg_from).map(d => (
                        <span className="badge rounded-pill bg-danger text-white mt-1">{d.no_msg}</span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}





            </div>
          </div>


          {/* Chat Window */}
          <div className="col-md-8 chat-window d-flex flex-column">

            {((param.id != undefined)) && (<>
              <div className="chat-header p-3 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <img src={(isMessage) ? (process.env.REACT_APP_API_BASE_URL + messageUserData.image1) : (profilePicture != process.env.REACT_APP_API_BASE_URL) ? profilePicture : defaultImage} className="rounded-circle me-2" alt="User" width={50} height={50} />
                  <div>
                    <strong>{(isMessage) ? messageName : chatUserName}</strong>
                    <p className="online-status">Recently Online</p>
                  </div>
                </div>
              </div>
              <div className="chat-body flex-grow-1 p-3 d-flex flex-column">
                {message?.map((res) => (
                  <div className={`chat-bubble align-self-${(res.mesg_from === userId) ? 'end' : 'start'} ${(res.mesg_from === userId) ? 'sent' : 'received'}`}>{res.message}
                    <span className={`float-right ms-4 messagetime ${(res.mesg_from === userId) ? 'text-white' : 'text-muted'}`} >{res.time}</span>
                  </div>
                ))}

                {/* <div className="chat-bubble received align-self-start">Hi
                <span className='float-right ms-4 messagetime' >09:00 am</span>
              </div>

              <div className="chat-bubble sent align-self-end">Hi</div>

              <div className="chat-bubble received align-self-start d-flex">
                <p className='w-100 mb-0'> Today I saw a mocking bird and thought about you... </p>
                <span className='float-end messagetime' >09:00 am</span>
              </div> */}

              </div>
              <div className="chat-footer p-3 d-flex align-items-center">
                <input type="text" className="form-control me-2" value={newMessage} onChange={handleInput} placeholder="Send a message" />
                {/* <button className="btn btn-danger">Send <IoSend /></button> */}
                <button onClick={handleMessageSubmit} className="btn btn-danger" disabled={error}> <IoSend /></button>
              </div>
            </>)}


          </div>
        </div>
      </div >
    </div>
  );
};

export default ChatApp;
